import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { List, X, WhatsappLogo } from "@phosphor-icons/react";
import { BRAND, NAV_LINKS, waLink } from "../../data/site";

export const Navbar = () => {
    const [scrolled, setScrolled] = useState(false);
    const [open, setOpen] = useState(false);

    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 24);
        window.addEventListener("scroll", onScroll);
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    return (
        <header
            data-testid="navbar"
            className={`fixed top-0 inset-x-0 z-[100] transition-[background-color,border-color,backdrop-filter] duration-500 ${
                scrolled
                    ? "bg-bg/90 backdrop-blur-md border-b border-border"
                    : "bg-transparent border-b border-transparent"
            }`}
        >
            <div className="mx-auto max-w-[1400px] px-6 md:px-10 h-[74px] flex items-center justify-between">
                <a
                    href="#top"
                    data-testid="navbar-logo"
                    className="font-display text-lg md:text-xl tracking-tight text-ink"
                >
                    ASTANA <span className="text-accent">KUCING'S</span>
                </a>

                <nav className="hidden md:flex items-center gap-9">
                    {NAV_LINKS.map((l) => (
                        <a
                            key={l.href}
                            href={l.href}
                            data-testid={`nav-${l.href.slice(1)}`}
                            className="text-sm text-ink-soft hover:text-ink transition-colors duration-300"
                        >
                            {l.label}
                        </a>
                    ))}
                    <a
                        href={waLink("Hai ASTANA KUCING'S, saya berminat dengan sangkar kucing anda.")}
                        target="_blank"
                        rel="noreferrer"
                        data-testid="nav-whatsapp-cta"
                        className="group inline-flex items-center gap-2 rounded-full bg-accent px-5 py-2.5 text-sm font-semibold text-white hover:bg-accent-hover transition-colors duration-300"
                    >
                        <WhatsappLogo size={18} weight="fill" />
                        Tempah
                    </a>
                </nav>

                <button
                    className="md:hidden text-ink"
                    onClick={() => setOpen((v) => !v)}
                    data-testid="nav-mobile-toggle"
                    aria-label="Menu"
                >
                    {open ? <X size={26} /> : <List size={26} />}
                </button>
            </div>

            <AnimatePresence>
                {open && (
                    <motion.nav
                        initial={{ height: 0, opacity: 0 }}
                        animate={{ height: "auto", opacity: 1 }}
                        exit={{ height: 0, opacity: 0 }}
                        transition={{ duration: 0.35 }}
                        className="md:hidden overflow-hidden bg-bg/95 backdrop-blur-md border-b border-border"
                    >
                        <div className="px-6 py-6 flex flex-col gap-5">
                            {NAV_LINKS.map((l) => (
                                <a
                                    key={l.href}
                                    href={l.href}
                                    onClick={() => setOpen(false)}
                                    className="text-base text-ink-soft hover:text-ink"
                                >
                                    {l.label}
                                </a>
                            ))}
                            <a
                                href={waLink("Hai ASTANA KUCING'S, saya berminat dengan sangkar kucing anda.")}
                                target="_blank"
                                rel="noreferrer"
                                className="inline-flex items-center justify-center gap-2 rounded-full bg-accent px-5 py-3 text-sm font-semibold text-white"
                            >
                                <WhatsappLogo size={18} weight="fill" /> Tempah Menerusi WhatsApp
                            </a>
                        </div>
                    </motion.nav>
                )}
            </AnimatePresence>
        </header>
    );
};
